var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 9.875H50.625V18.3125",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 51.125H9.375V42.6875",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 9.875H9.375V18.3125",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5C38.2843 45.5 45 38.7843 45 30.5C45 22.2157 38.2843 15.5 30 15.5C21.7157 15.5 15 22.2157 15 30.5C15 38.7843 21.7157 45.5 30 45.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 30.5C25.9283 30.5 27.1875 29.2408 27.1875 27.6875C27.1875 26.1342 25.9283 24.875 24.375 24.875C22.8217 24.875 21.5625 26.1342 21.5625 27.6875C21.5625 29.2408 22.8217 30.5 24.375 30.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 30.5C37.1783 30.5 38.4375 29.2408 38.4375 27.6875C38.4375 26.1342 37.1783 24.875 35.625 24.875C34.0717 24.875 32.8125 26.1342 32.8125 27.6875C32.8125 29.2408 34.0717 30.5 35.625 30.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 36.125C34.3031 37.2969 31.9031 38 30 38C28.0969 38 25.6969 37.2969 24.375 36.125",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7812 51.125L44.5312 54.875L52.0312 47.375",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.1c7985b04b5d9a5e5d0348eef85edf55.svg";
export { ForwardRef as ReactComponent };